import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { env } from "@environments/environment";

@Injectable({ providedIn: "root" })
export class BeneficiaryController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/beneficiaries`;

  public beneficiariesUpdate(distributionId: number) {
    return this.httpService.get(`${this.baseUrl}/update/${distributionId}`, { responseType: "text" });
  }

  public clearPostponed(distributionId: number) {
    return this.httpService.get(`${this.baseUrl}/clear-postponed/${distributionId}`, { responseType: "text" });
  }

  public withdrawPostponed(beneficiaryId: number) {
    return this.httpService.get(`${this.baseUrl}/withdraw-postponed/${beneficiaryId}`, { responseType: "text" });
  }

}
